import React, { PureComponent } from 'react'
import { string, object, shape } from 'prop-types'
import { Text, SvgGrid, PreSeasonPerformanceLine } from 'components'
import { translate } from 'react-i18next'

const svgViewBox = '0 0 215 110'
const viewBox = { x: 28.3, y: 0.5, width: 186.2, height: 97.1 }

@translate()
export class PanelLineChart extends PureComponent {
    static propTypes = {
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }).isRequired,
        typeSelected: string
    }

    render() {
        const { curvesParams, typeSelected, className, withWhiteBg, t, tReady, i18n, ...otherProps } = this.props

        return (
            <div className={['Panel-Chart Line', className]} {...otherProps}>
                <Text className="ChartLegend Y">{t('game.PRE_SEASON.panelLineChartYLabel')}</Text>
                <svg viewBox={svgViewBox} className={{ WhiteBg: withWhiteBg }}>
                    <SvgGrid viewBox={viewBox} zeroLabel="0%" xLabel="100%" yLabel="100%" clipId="viewBoxClip-panelLineChart" />
                    <PreSeasonPerformanceLine curvesParams={curvesParams} typeSelected={typeSelected} outputViewBox={viewBox} clipPath="url(#viewBoxClip-panelLineChart)" {...otherProps} />
                </svg>
                <Text className="ChartLegend X">{t('game.PRE_SEASON.panelLineChartXLabel')}</Text>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Panel/PanelLineChart.js